// Canadian provinces/territories + GST/HST rates (display only; Stripe Tax is the source of truth at checkout)
export const PROVINCES = [
  ['AB', 'Alberta'], ['BC', 'British Columbia'], ['MB', 'Manitoba'], ['NB', 'New Brunswick'],
  ['NL', 'Newfoundland and Labrador'], ['NS', 'Nova Scotia'], ['NT', 'Northwest Territories'], ['NU', 'Nunavut'],
  ['ON', 'Ontario'], ['PE', 'Prince Edward Island'], ['QC', 'Quebec'], ['SK', 'Saskatchewan'], ['YT', 'Yukon'],
];

export const FEDERAL_TAX = {
  ON: { label: 'HST', rate: 13 }, NB: { label: 'HST', rate: 15 }, NL: { label: 'HST', rate: 15 }, NS: { label: 'HST', rate: 15 }, PE: { label: 'HST', rate: 15 },
  AB: { label: 'GST', rate: 5 }, BC: { label: 'GST', rate: 5 }, MB: { label: 'GST', rate: 5 }, NT: { label: 'GST', rate: 5 }, NU: { label: 'GST', rate: 5 },
  QC: { label: 'GST', rate: 5 }, SK: { label: 'GST', rate: 5 }, YT: { label: 'GST', rate: 5 },
};

export const formatPostalCode = (v) => {
  const s = (v || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 6);
  return s.length > 3 ? `${s.slice(0, 3)} ${s.slice(3)}` : s;
};

export const isValidPostalCode = (v) => /^[A-Z]\d[A-Z] \d[A-Z]\d$/.test(v || '');
